import Factory from "@Shared/Factory";
import { unwrapChosenPackageItem } from "@Api/Suppliers/chosenPackages";
import api from "..";
const collectChosenPackages = (packages, data) => {
    if (Array.isArray(data)) {
        for (const datum of data) {
            const unwrapped = unwrapChosenPackageItem(datum);
            if (unwrapped) {
                packages.push(unwrapped);
            }
        }
        return;
    }
    if (!data || typeof data !== "object") {
        return;
    }
    const payload = data;
    const items = payload.items ?? payload.packages ?? [];
    for (const datum of items) {
        const unwrapped = unwrapChosenPackageItem(datum);
        if (unwrapped) {
            packages.push(unwrapped);
        }
    }
};
const PAGE_FETCH_LIMIT = 100;
const fetchAllChosenPackages = async (url, params = {}) => {
    const packages = [];
    const fetchPage = async (pageUrl, pageParams = {}) => {
        const { data } = await api.get(pageUrl, { params: pageParams });
        collectChosenPackages(packages, data);
        if (!data || typeof data !== "object" || Array.isArray(data)) {
            return;
        }
        const payload = data;
        if (payload.links?.next) {
            await fetchPage(payload.links.next);
            return;
        }
        const { totalPages } = data;
        const currentPage = Number(pageParams.page ?? 1);
        if (typeof totalPages === "number" && currentPage < totalPages) {
            await fetchPage(pageUrl, {
                ...pageParams,
                page: currentPage + 1,
            });
        }
    };
    await fetchPage(url, { page: 1, limit: PAGE_FETCH_LIMIT, ...params });
    return packages;
};
export const getAll = async (customerId, inclDel = false) => fetchAllChosenPackages(`/customers/${customerId}/predict-instant/chosen`, {
    inclDel,
});
export const findRaw = (customerId, packageId, inclDel = false) => api
    .get(`/customers/${customerId}/predict-instant/chosen/${packageId}`, {
    params: { inclDel },
})
    .then((result) => {
    const payload = Array.isArray(result.data)
        ? result.data[0]
        : result.data;
    const unwrapped = unwrapChosenPackageItem(payload?.item ?? payload);
    if (!unwrapped) {
        throw new Error("Chosen package not found");
    }
    return unwrapped;
});
export const find = (customerId, packageId, inclDel = false) => api
    .get(`/customers/${customerId}/predict-instant/chosen/${packageId}`, {
    params: { inclDel },
})
    .then((result) => Factory.GeneratedPackage(unwrapChosenPackageItem(result.data?.item ?? result.data)));
